import * as React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { URL_PATHS } from "../../src/routes";
import { UserStatus } from "../../src/generated/lib-domain/user";
import { AppState } from "../../src/store";
import IncompleteRegisterPage from "../pages/IncompleteRegister";

const IncompleteRegisterContainer = (): JSX.Element => {
    const myUser = useSelector((state: AppState) => state.myData.user);
    if (myUser.status !== UserStatus.Created) {
        return <Redirect to={URL_PATHS.myPage()} />;
    }
    return <IncompleteRegisterPage />;
};

export default IncompleteRegisterContainer;
